import LoginDialog from '@/components/login-dialog';
import { useAddToListButton } from '@/hooks/Wishlist/AddToListButton/useAddToListButton';
import clsx from 'clsx';
import { useCommonToasts } from './useCommonToasts';

const AddToListButton = props => {
  const {
    buttonText,
    errorToastProps,
    successToastProps,
    isSelected,
    openLoginDialog,
    setOpenLoginDialog,
    handleClick,
    afterLogin,
    loginConfirmLoading,
    setLoginConfirmLoading,
  } = useAddToListButton(props);
  const { classes = {} } = props;

  useCommonToasts({
    errorToastProps,
    successToastProps,
  });

  return (
    <>
      <button
        type='button'
        aria-label='Add to Showroom'
        className={clsx(isSelected ? classes.root_selected : classes.root)}
        onClick={handleClick}
      >
        {buttonText}
      </button>
      <LoginDialog
        open={openLoginDialog}
        setOpen={setOpenLoginDialog}
        afterLogin={afterLogin}
        confirmLoading={loginConfirmLoading}
        setLoginConfirmLoading={setLoginConfirmLoading}
      />
    </>
  );
};

export default AddToListButton;
